export { default as translations } from './translations.json';

/**
 * Get analytics from listing.
 * @param {Object|null} listing
 * @returns {Object}
 */
export const getAnalytics = (listing) =>
  listing?.attributes?.metadata?.analytics || { views: [], inquiries: [], totalViews: 0, totalInquiries: 0, conversionRate: 0 };

/**
 * Calculate weekly view trend.
 * Returns percentage change: positive = growth.
 * @param {Array} viewEntries — [{ date, count }]
 * @returns {number}
 */
export const calculateWeeklyTrend = (viewEntries = []) => {
  if (!viewEntries.length) return 0;
  const sorted = [...viewEntries].sort((a, b) => b.date.localeCompare(a.date));
  const thisWeek = sorted.slice(0, 7).reduce((s, e) => s + (e.count || 0), 0);
  const lastWeek = sorted.slice(7, 14).reduce((s, e) => s + (e.count || 0), 0);
  if (lastWeek === 0) return thisWeek > 0 ? 100 : 0;
  return Math.round(((thisWeek - lastWeek) / lastWeek) * 100);
};
